import React from "react";
import { useTranslation } from "react-i18next";
import Hero from "src/components/Hero/Hero";
import TitleSection from "src/components/TitleSection/TitleSection";
import ReactMarkdown from "react-markdown";
import EventFinished from "src/components/EventFinished";
import TBCBPageWrapper from "src/components/Promotions/TBCB/TBCBPageWrapper";
import TBCBDrawDatesSection from "src/components/Promotions/TBCB/TBCBDrawDatesSection";
import TBCBPrizeTablesSection from "src/components/Promotions/TBCB/TBCBPrizeTablesSection";
import TBCBHowItWorksSection from "src/components/Promotions/TBCB/TBCBHowItWorksSection";
import { ListText } from "src/components/Promotions/TBCB/TBCBStyledComponents";

const TripleBarrelCashBlastMarch2026 = () => {
  const { t } = useTranslation();
  const heroImage = t("tripleBarrelCashBlastMarch2026.hero.image");
  const translationKeyPrefix = "tripleBarrelCashBlastMarch2026";

  return (
    <TBCBPageWrapper>
      <EventFinished
        scheduleKeyName="tripleBarrelCashBlastMarch2026"
        eventType="promotion"
      />
      <Hero
        image={heroImage}
        bgImage={t(`${translationKeyPrefix}.hero.bgImage`)}
        imageAlt={t(`${translationKeyPrefix}.hero.imageAlt`)}
        fluidImage={heroImage ? false : true}
      />
      <container-div>
        <TitleSection
          as={"h2"}
          title={t(`${translationKeyPrefix}.content.title`)}
          text={t(`${translationKeyPrefix}.content.subtitle`)}
          borderColor="#d59947"
          className="mt-4 pb-2"
        />
        <ListText>
          <ReactMarkdown>
            {t(`${translationKeyPrefix}.content.text`)}
          </ReactMarkdown>
        </ListText>
        <TBCBDrawDatesSection translationKeyPrefix={translationKeyPrefix} />
        <TBCBPrizeTablesSection translationKeyPrefix={translationKeyPrefix} imagePath="march-2026" />
      </container-div>
      <TBCBHowItWorksSection translationKeyPrefix={translationKeyPrefix} />
    </TBCBPageWrapper>
  );
};

export default TripleBarrelCashBlastMarch2026;
